import BetTypesFilter from './BetTypesFilter';
export default BetTypesFilter;
